import React from 'react';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import i18n from 'i18n';
import Tag from 'components/common/Tag';
import Button from 'components/common/Button';
import SelectField from 'components/common/SelectField';
import DatepickerField from 'components/common/DatepickerField';
import MessageCardDialog from 'components/OrderAggregators/components/MessageCardDialog';
import ReceiverDialog from 'components/OrderAggregators/components/ReceiverDialog';
import ShipperDialog from 'components/OrderAggregators/components/ShipperDialog';
import WrappingInfoDialog from 'components/OrderAggregators/components/WrappingInfoDialog';
import { get } from 'lodash';
import icBtnUpPC1x from 'assets/images/PC/@1x/ic_btn_up.png';
import icBtnUpPC2x from 'assets/images/PC/@2x/ic_btn_up@2x.png';
import icBtnUpSP2x from 'assets/images/SP/@2x/ic_btn_up@2x.png';
import icBtnUpSP3x from 'assets/images/SP/@3x/ic_btn_up@3x.png';
import icBtnDownPC1x from 'assets/images/PC/@1x/ic_btn_down.png';
import icBtnDownPC2x from 'assets/images/PC/@2x/ic_btn_down@2x.png';
import icBtnDownSP2x from 'assets/images/SP/@2x/ic_btn_down@2x.png';
import icBtnDownSP3x from 'assets/images/SP/@3x/ic_btn_down@3x.png';
import icDatePC1x from 'assets/images/PC/@1x/ic_date.png';
import icDatePC2x from 'assets/images/PC/@2x/ic_date@2x.png';
import icDateSP2x from 'assets/images/SP/@2x/ic_date@2x.png';
import icDateSP3x from 'assets/images/SP/@3x/ic_date@3x.png';
import {
  commonStyle,
  pcStyle,
  spStyle
} from 'components/OrderAggregators/styles/order';
import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import Colors from 'constants/colors';
import {
  renderAddressOneLine,
  renderWrappingInfoDetail,
  renderMessageCardInfo,
  handleWrappingInfoDialogSave,
  handleMessageCardDialogSave,
  updateReferringData,
  handleValidatedOnChange,
  referringDataTemplate,
  isInvalidReceiverValues
} from 'components/OrderAggregators/scripts/order';
import { css } from 'styled-components';
import ReferredOrderSelect from 'components/OrderAggregators/components/ReferredOrderSelect';
import { required } from 'validation/validators';
import SessionManager from 'util/session-manager';

class Order extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: true
    };
    this.wrappingInfoDialogRef = React.createRef();
    this.messageCardDialogRef = React.createRef();
    this.receiverDialogRef = React.createRef();
    this.shipperDialogRef = React.createRef();
    this.contentRef = React.createRef();
    this.purchaseNumOptions = Array.from(
      Array(+process.env.REACT_APP_ORDER_PURCHASE_ITEMS_NUM_MAX)
    ).map((_, i) => i + 1);
  }

  handleClickToggle() {
    this.setState({
      opened: !this.state.opened
    });
  }

  handleReceiverDialogSave(receiverValues) {
    const { fieldName, change } = this.props;
    change(`${fieldName}.receiver`, receiverValues);

    let storedData;
    try {
      storedData = SessionManager.load();
    } catch (error) {
      switch (error.name) {
        case 'NoSessionError':
        case 'SessionExpiredError':
        case 'LoadDataError':
          this.props.push('/error');
          return;

        default:
          throw error;
      }
    }
    const ordersIndex = fieldName.match(/\d+/)[0];
    storedData.orders[ordersIndex].receiver = receiverValues;
    SessionManager.save(storedData);
  }

  handleShipperDialogSave(shipperValues) {
    const { fieldName, change } = this.props;
    change(`${fieldName}.shipper`, shipperValues);

    let storedData;
    try {
      storedData = SessionManager.load();
    } catch (error) {
      switch (error.name) {
        case 'NoSessionError':
        case 'SessionExpiredError':
        case 'LoadDataError':
          this.props.push('/error');
          return;

        default:
          throw error;
      }
    }
    const ordersIndex = fieldName.match(/\d+/)[0];
    storedData.orders[ordersIndex].shipper = shipperValues;
    SessionManager.save(storedData);
  }

  handleClickComplete(index) {
    const { onClickComplete } = this.props;
    onClickComplete(index);

    // 参照先データのアップデート
    updateReferringData(this.props);
    let storedData;
    try {
      storedData = SessionManager.load();
    } catch (error) {
      switch (error.name) {
        case 'NoSessionError':
        case 'SessionExpiredError':
        case 'LoadDataError':
          this.props.push('/error');
          return;

        default:
          throw error;
      }
    }
    storedData.orders[index].purchaseItem.num = this.props.orders[index].purchaseItem.num;
    storedData.orders[index].purchaseItem.validatedOn = this.props.orders[index].purchaseItem.validatedOn;
    storedData.orders[index].purchaseItem.expiredOn = this.props.orders[index].purchaseItem.expiredOn;
    SessionManager.save(storedData);
  }

  render() {
    const {
      className,
      index,
      fieldName,
      getState,
      datepickerMin,
      datepickerMax,
      fetchAddress,
      onClickCancel,
      updateOrder,
      referredOrderOptions,
      orders,
      change,
      invalidOrder
    } = this.props;
    const formValues = get(getState().values, fieldName);

    if (formValues == null) {
      return null;
    }

    return (
      <div className={className}>
        <div className="header-panel">
          <button
            type="button"
            className="btn-toggle"
            onClick={() => this.handleClickToggle()}
          >
            {this.state.opened ? (
              <Image
                pc1x={icBtnUpPC1x}
                pc2x={icBtnUpPC2x}
                sp2x={icBtnUpSP2x}
                sp3x={icBtnUpSP3x}
                alt="ic_btn_up"
              />
            ) : (
              <Image
                pc1x={icBtnDownPC1x}
                pc2x={icBtnDownPC2x}
                sp2x={icBtnDownSP2x}
                sp3x={icBtnDownSP3x}
                alt="ic_btn_down"
              />
            )}
          </button>
          <h2>{`${i18n.t('orderAggregators:common:order.order')}${index}`}</h2>
          <button
            type="button"
            className="header-btn btn-cancel"
            onClick={() => onClickCancel(index - 1)}
          >
            {i18n.t('common:cancel')}
          </button>
          <button
            type="button"
            disabled={invalidOrder(orders[index - 1])}
            className="header-btn btn-complete"
            onClick={() => this.handleClickComplete(index - 1)}
          >
            {i18n.t('common:complete')}
          </button>
        </div>
        <div
          className={`order-content ${this.state.opened ? '' : 'close'}`}
          style={{
            maxHeight: this.contentHeight
          }}
          ref={this.contentRef}
        >
          <table>
            <tbody>
              <tr>
                <th>
                  <span className="required-cell-wrapper">
                    {i18n.t('orderAggregators:common:order.orderCount')}
                    <Tag>{i18n.t('common:required')}</Tag>
                  </span>
                </th>
                <td>
                  <SelectField
                    options={this.purchaseNumOptions}
                    name={`${fieldName}.purchaseItem.num`}
                  />
                </td>
              </tr>
              <tr className="row-variable">
                <th>
                  <span className="required-cell-wrapper">
                    {i18n.t('orderAggregators:common:order.validityPeriod')}
                    <Tag>{i18n.t('common:required')}</Tag>
                  </span>
                </th>
                <td className="validity-period-container">
                  <div className="validity-period">
                    <DatepickerField
                      onChange={val => handleValidatedOnChange(this.props, val, true)}
                      name={`${fieldName}.purchaseItem.validatedOn`}
                      minDate={datepickerMin.format(
                        i18n.t('common:dateFormat.default')
                      )}
                      maxDate={datepickerMax.format(
                        i18n.t('common:dateFormat.default')
                      )}
                      validate={value => required(value)}
                    />
                    <div className="expired-on">
                      <Image
                        pc1x={icDatePC1x}
                        pc2x={icDatePC2x}
                        sp2x={icDateSP2x}
                        sp3x={icDateSP3x}
                        alt="ic_date"
                      />
                      <DatepickerField
                        name={`${fieldName}.purchaseItem.expiredOn`}
                        disabled={true}
                      />
                    </div>
                  </div>
                </td>
              </tr>
              <tr className="row-variable">
                <th>{i18n.t('orderAggregators:common:order.wrappingInfo')}</th>
                <td
                  className="has-dialog"
                  onClick={() => this.wrappingInfoDialogRef.current.open()}
                >
                  <div className="cell-wrapper">
                    <p className="value multiline">
                      {renderWrappingInfoDetail(formValues.wrappingInfo)}
                    </p>
                    <Button
                      className="G-edit"
                      buttonType="G-edit"
                      type="button"
                    >
                      {i18n.t('common:edit')}
                    </Button>
                  </div>
                </td>
              </tr>
              <tr className="row-variable">
                <th>{i18n.t('orderAggregators:common:order.messageCard')}</th>
                <td
                  className="has-dialog"
                  onClick={() => this.messageCardDialogRef.current.open()}
                >
                  <div className="cell-wrapper">
                    <p className="value multiline">
                      {renderMessageCardInfo(formValues.wrappingInfo)}
                    </p>
                    <Button
                      className="G-edit"
                      buttonType="G-edit"
                      type="button"
                    >
                      {i18n.t('common:edit')}
                    </Button>
                  </div>
                </td>
              </tr>
              {index > 1 && (
                <tr key={index}>
                  <td colSpan="2">
                    <ReferredOrderSelect
                      name={`${fieldName}.referringOrderInfo`}
                      options={referredOrderOptions}
                      index={index}
                      formValues={formValues}
                      updateOrder={updateOrder}
                      change={change}
                    />
                  </td>
                </tr>
              )}
              <tr>
                <th>
                  <span className="required-cell-wrapper">
                    {i18n.t('orderAggregators:common:order.receiver')}
                    <Tag>{i18n.t('common:required')}</Tag>
                  </span>
                </th>
                <td
                  className="has-dialog"
                  onClick={() => this.receiverDialogRef.current.open()}
                >
                  <div className="cell-wrapper">
                    <span className="value ellipsis">
                      {renderAddressOneLine(formValues.receiver)}
                    </span>
                    {formValues.referringOrderInfo.checked ? (
                      <Button
                        className="G-confirm"
                        buttonType="G-confirm"
                        type="button"
                        onClick={() => this.receiverDialogRef.current.open()}
                      >
                        {i18n.t('common:confirm')}
                      </Button>
                    ) : (
                      <Button
                        className="G-edit"
                        buttonType="G-edit"
                        type="button"
                        onClick={() => this.receiverDialogRef.current.open()}
                      >
                        {i18n.t('common:edit')}
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <th>
                  <span className="required-cell-wrapper">
                    {i18n.t('orderAggregators:common:order.from')}
                    <Tag>{i18n.t('common:required')}</Tag>
                  </span>
                </th>
                <td
                  className="has-dialog"
                  onClick={() => this.shipperDialogRef.current.open()}
                >
                  <div className="cell-wrapper">
                    <span className="value ellipsis">
                      {renderAddressOneLine(formValues.shipper)}
                    </span>
                    {formValues.referringOrderInfo.checked ? (
                      <Button
                        className="G-confirm"
                        buttonType="G-confirm"
                        type="button"
                        onClick={() => this.shipperDialogRef.current.open()}
                      >
                        {i18n.t('common:confirm')}
                      </Button>
                    ) : (
                      <Button
                        className="G-edit"
                        buttonType="G-edit"
                        type="button"
                        onClick={() => this.shipperDialogRef.current.open()}
                      >
                        {i18n.t('common:edit')}
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <WrappingInfoDialog
          dialogRef={this.wrappingInfoDialogRef}
          onSubmit={v => handleWrappingInfoDialogSave(this.props, v, true)}
          initialValues={{
            wrappingType: formValues.wrappingInfo.wrappingType,
            inscription: formValues.wrappingInfo.inscription,
            shipperName: formValues.wrappingInfo.shipperName,
            inscriptionType: formValues.wrappingInfo.inscriptionType,
            shipperNameType: formValues.wrappingInfo.shipperNameType
          }}
        />
        <MessageCardDialog
          dialogRef={this.messageCardDialogRef}
          onSubmit={v => handleMessageCardDialogSave(this.props, v, true)}
          initialValues={{
            messageCard: formValues.wrappingInfo.messageCard,
            messageCardType: formValues.wrappingInfo.messageCardType
          }}
        />
        <ReceiverDialog
          dialogRef={this.receiverDialogRef}
          onSubmit={v => this.handleReceiverDialogSave(v)}
          initialValues={formValues.receiver}
          fetchAddress={fetchAddress}
          referringDataTemplate={() =>
            referringDataTemplate(formValues.receiver)
          }
          isConfirm={formValues.referringOrderInfo.checked}
        />
        <ShipperDialog
          dialogRef={this.shipperDialogRef}
          onSubmit={v => this.handleShipperDialogSave(v)}
          initialValues={formValues.shipper}
          fetchAddress={fetchAddress}
          referringDataTemplate={() =>
            referringDataTemplate(formValues.shipper, 'shipper')
          }
          isInvalidReceiverValues={() => isInvalidReceiverValues(this.props)}
          isConfirm={formValues.referringOrderInfo.checked}
          orders={orders}
          index={index - 1}
          options={referredOrderOptions}
        />
      </div>
    );
  }
}
const commonStyle2 = css`
  .btn-cancel {
    ${FontStyles.text8};

    padding: 0;
    color: ${Colors.orange1};
    border: 0;
    outline: none;
    background-color: ${Colors.white1};
    margin: 0 16px !important;
    cursor: pointer;

    &:hover,
    &:active {
      color: ${Colors.orange3};
      cursor: pointer;
    }
  }

  .btn-complete {
    ${FontStyles.text7};

    color: ${Colors.white1};
    outline: none;
    background-color: ${Colors.orange1};
    padding: 4px 16px;
    border: 0;
    margin: 0 !important;
    cursor: pointer;

    &:hover,
    &:active {
      background-color: ${Colors.orange3};
      cursor: pointer;
    }

    &:disabled {
      color: ${Colors.gray1};
      background-color: ${Colors.gray3};
      opacity: 1;
      font-weight: normal;

      &:hover {
        background-color: ${Colors.gray3};
      }
    }
  }

  ${ReferredOrderSelect} {
    ${SelectField} {
      height: 40px;
    }
  }

  ${SelectField},
  ${DatepickerField} {
    margin: 0 !important;
  }
`;

const pcStyle2 = CustomMedia.greaterThan('umedium')`
  box-shadow: 0 0 0 4px ${Colors.orange1} inset;

  .validity-period-container {
    padding: 0 16px !important;
  }

  .validity-period > .expired-on {
    display: inline-block;
  }
`;

const spStyle2 = CustomMedia.lessThan('medium')`
  box-shadow: 0 0 0 2px ${Colors.orange1} inset;
`;

export default applyStyles(Order)(
  commonStyle,
  commonStyle2,
  pcStyle,
  pcStyle2,
  spStyle,
  spStyle2
);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/OrderEdit.js